/**
 * Matriz papel x permissao (SPEC.md secao 5.3).
 *
 * Papeis de sistema tem isSystem = true: nao podem ser apagados nem ter a chave
 * alterada. ADMIN_MASTER nao aparece na matriz porque recebe TODAS as permissoes
 * do catalogo automaticamente — assim, permissao nova nunca "esquece" o admin.
 */
import { PERMISSION_KEYS } from './permissions.js';
export const ROLE_KEYS = [
    'ADMIN_MASTER',
    'OPERATOR',
    'SHIPPER',
    'CARRIER_MANAGER',
    'DRIVER',
    'AUDITOR',
];
export const ROLES = [
    {
        key: 'ADMIN_MASTER',
        name: 'Administrador Master',
        description: 'Acesso total. Gerencia papéis, permissões e configuração da plataforma.',
        scope: 'GLOBAL',
        isSystem: true,
    },
    {
        key: 'OPERATOR',
        name: 'Operador',
        description: 'Verifica documentos e media ocorrências. Sem acesso à configuração.',
        scope: 'GLOBAL',
        isSystem: true,
    },
    {
        key: 'SHIPPER',
        name: 'Embarcador',
        description: 'Publica e gerencia os fretes da própria organização.',
        scope: 'ORG',
        isSystem: true,
        selfAssignable: true,
    },
    {
        key: 'CARRIER_MANAGER',
        name: 'Gestor de Transportadora',
        description: 'Gerencia frota, motoristas e candidaturas da transportadora.',
        scope: 'ORG',
        isSystem: true,
    },
    {
        key: 'DRIVER',
        name: 'Motorista',
        description: 'Escolhe fretes, executa e reporta checkpoints.',
        scope: 'SELF',
        isSystem: true,
        selfAssignable: true,
    },
    {
        key: 'AUDITOR',
        name: 'Auditor',
        description: 'Somente leitura, incluindo trilha de auditoria.',
        scope: 'GLOBAL',
        isSystem: true,
    },
];
/** Permissoes por papel. ADMIN_MASTER e resolvido dinamicamente (todas). */
const MATRIX = {
    OPERATOR: [
        'user:read',
        'role:read',
        'driver:read',
        'driver:verify',
        'driver:reject',
        'vehicle:read',
        'vehicle:verify',
        'org:read',
        'org:verify',
        'freight:read:public',
        'freight:read:all',
        'freight:cancel:any',
        'assignment:read:all',
        'rating:read',
        'rating:moderate',
        'admin:audit:read',
        'admin:metrics',
    ],
    SHIPPER: [
        'org:crud:own',
        'org:member:manage',
        'driver:read',
        'vehicle:read',
        'freight:read:public',
        'freight:read:own',
        'freight:create',
        'freight:update:own',
        'freight:publish',
        'freight:cancel:own',
        'bid:read:freight',
        'bid:accept',
        'bid:reject',
        'assignment:read:own',
        'assignment:complete',
        'rating:create',
        'rating:read',
    ],
    CARRIER_MANAGER: [
        'org:crud:own',
        'org:member:manage',
        'driver:read',
        'vehicle:read',
        'vehicle:crud:own',
        'freight:read:public',
        'bid:read:own',
        'bid:create',
        'bid:withdraw:own',
        'assignment:read:own',
        'checkpoint:create',
        'rating:create',
        'rating:read',
    ],
    DRIVER: [
        'driver:read:own',
        'driver:update:own',
        'vehicle:crud:own',
        'freight:read:public',
        'bid:read:own',
        'bid:create',
        'bid:withdraw:own',
        'assignment:read:own',
        'checkpoint:create',
        'rating:create',
        'rating:read',
    ],
    AUDITOR: [
        'user:read',
        'role:read',
        'driver:read',
        'vehicle:read',
        'org:read',
        'freight:read:public',
        'freight:read:all',
        'assignment:read:all',
        'rating:read',
        'admin:audit:read',
        'admin:metrics',
    ],
};
/**
 * Permissoes efetivas de um papel. ADMIN_MASTER recebe o catalogo inteiro,
 * de modo que uma permissao adicionada ao catalogo ja vale para ele.
 */
export function permissionsForRole(role) {
    if (role === 'ADMIN_MASTER')
        return [...PERMISSION_KEYS];
    return MATRIX[role];
}
export const ROLE_PERMISSION_MATRIX = Object.fromEntries(ROLE_KEYS.map((r) => [r, permissionsForRole(r)]));
//# sourceMappingURL=matrix.js.map